import React from "react";
import { getFileUrl } from "../../helpers/extractors";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

function HeroItem({ heroIndex, selectionIndex, hero }) {
  return (
    <div
      className={`relative rounded-sm block`}
      style={{
        minWidth: "100%",
        minHeight: "100%",
      }}
    >
      <img
        src={getFileUrl(hero.imageUrl)}
        alt="Imag"
        className="h-full w-full object-cover rounded-sm"
        // loading="lazy"
      />
      <div className="absolute inset-0 bg-black bg-opacity-25 rounded-sm"></div>
      <Fade bottom>
        <div className="absolute top-[170px] max-md:top-[120px] w-full">
          <p className="text-white font-[500] text-[6em] max-lg:text-[4em] max-md:text-[2em] mb-6 max-lg:mb-4 max-md:mb-2 max-w-[750px] mx-auto leading-tight">
            {hero.title}
          </p>
          <div className="mb-8 max-lg:mb-6 max-md:mb-4">
          <span className="text-white px-2.5 text-base drop-shadow">
            {hero.extraText}
          </span>
          </div>
          <Link to={hero.url}>
            <button className="bg-white text-black rounded-md py-3 px-6 max-md:px-3 max-md:py-2 font-semibold hover:bg-black hover:text-white">
              {hero.buttonText}
            </button>
          </Link>
        </div>
      </Fade>
    </div>
  );
}

export default HeroItem;
